import { TILE_SIZE } from '../../constants/map';

export function getTilePixelCoords(tileNumber: YMaps.TTileNumber): YMaps.TPixelCoord {
  return [tileNumber[0] * TILE_SIZE, tileNumber[1] * TILE_SIZE];
}
